module.exports = __webpack_public_path__ + "static/media/logoSN_ConociendoSantaReliquia.9b71787d.png";